import CardIconOne from "../../assets/icons/card-icon-1.svg";
import CardIconTwo from "../../assets/icons/card-icon-2.svg";
import CardIconThree from "../../assets/icons/card-icon-3.svg";

const constants = [
  {
    icon: CardIconOne,
    title: "Use Sentinel dVPN",
    description:
      "Browse your favorite website safely from anywhere in the world by using the sentinel dVPN app or any of the other dVPN apps built using Sentinel.",
    btn: {
      title: "Download dVPN",
      onClick: () => {
        window.open("https://docs.sentinel.co/getting-started/apps");
      },
    },
  },
  {
    icon: CardIconTwo,
    title: "Build your own dVPN App",
    description:
      "Effortlessly launch your own whitelabel VPN application without any setup and server costs using the Sentinel Opensource Whitelabel SDK.",
    btn: {
      title: "Build a dVPN App",
      onClick: () => {
        window.open("https://docs.sentinel.co/sentinel-hub");
      },
    },
  },
  {
    icon: CardIconThree,
    title: "Run a Node",
    description:
      "Earn passive income by running a node or buying a router and selling your unused bandwidth to the Sentinel network.",
    btn: {
      title: "Run a Node",
      onClick: () => {
        window.open("https://docs.sentinel.co/node-setup");
      },
    },
  },
];

export default constants;
